import Modal from "components/DesignSystem/Modal/Modal";
import { FormikForm } from "components/FormikForm/FormikForm";
import { YYYY_MM_DD } from "constants/date";
import dayjs from "dayjs";
import { FormikValues } from "formik";
import { internalTicketETDUpdateSchema } from "formValidations/ticketSchema";
import { useToast } from "hooks/useToast";
import { useAddTicketETDMutation } from "store/apis/chatTicket";
import { BackendError } from "types/utils/error";
import { formatDate } from "utils/formatDate";
import { EtdUpdateForm } from "./EtdUpdateForm";

type TicketEtdModalProps = {
  isOpen: boolean;
  close: () => void;
  ticketId: string;
  currentEtd: string;
  channelUrl?: string | null;
  groupId: string;
  ticketName: string;
  title?: string;
  handleSuccess?: () => void;
};

export const TicketEtdModal = ({
  isOpen,
  close,
  ticketId,
  currentEtd,
  channelUrl,
  groupId,
  ticketName,
  title,
  handleSuccess,
}: TicketEtdModalProps) => {
  const { alertToast, successToast } = useToast();
  const [addTicketEtd, { isLoading: isAdding }] = useAddTicketETDMutation();
  const today = dayjs().startOf("day");

  const handleSubmit = async (values: FormikValues) => {
    try {
      const informCustomerDetails = values.inform_customer
        ? {
            channel_url: values.channel,
            chat_message: values.message,
          }
        : {};

      const payload = {
        reason: values.reason,
        etd_date: dayjs(values.estimatedDeliveryTime).format(YYYY_MM_DD),
        ticketId,
        inform_customer: values.inform_customer,
        ...informCustomerDetails,
      };

      await addTicketEtd(payload).unwrap();
      successToast({ message: "ETD added successfully" });
      close();
      handleSuccess?.();
    } catch (error) {
      alertToast({
        message: (error as BackendError)?.data?.error?.message,
      });
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content asChild>
        <FormikForm
          initialValues={{
            estimatedDeliveryTime: currentEtd,
            reason: "",
            inform_customer: false,
            channel: channelUrl || "",
            message: "",
          }}
          onSubmit={handleSubmit}
          validationSchema={internalTicketETDUpdateSchema}
          validateOnChange
        >
          <EtdUpdateForm
            isAdding={isAdding}
            title={title}
            hideCustomerMessage
          />
        </FormikForm>
      </Modal.Content>
    </Modal.Root>
  );
};
